export default "__VITE_ASSET__CraBCMsU__"